/* THIS IS A GENERATED FILE - DO NOT EDIT                                                */
/* See codegen.yml for info or run bazel build to re-generate                            */

import { JSONTypePolicy, connectionTypePolicy, dateTypePolicy } from './fieldpolicy'

export const typePolicies = {
  AccessControl: {
    fields: {
      createdAt: dateTypePolicy,
      incidentUsers: connectionTypePolicy,
      inspectionReportPresets: connectionTypePolicy,
      inspectionSchedules: connectionTypePolicy,
      inspectionTemplates: connectionTypePolicy,
      inspectors: connectionTypePolicy,
      projectAssignees: connectionTypePolicy,
      projectBoards: connectionTypePolicy,
      taskAssignees: connectionTypePolicy,
      taskAssigneesV2: connectionTypePolicy,
      updatedAt: dateTypePolicy,
      users: connectionTypePolicy,
      vendors: connectionTypePolicy,
      workTypes: connectionTypePolicy,
    },
  },
  AreaType: { fields: { itemTypes: connectionTypePolicy } },
  BoxSystemConfig: { fields: { Expiry: dateTypePolicy } },
  Building: {
    fields: { areas: connectionTypePolicy, floors: connectionTypePolicy },
  },
  BulkOperation: {
    fields: {
      createdAt: dateTypePolicy,
      completedAt: dateTypePolicy,
      variables: connectionTypePolicy,
      results: connectionTypePolicy,
    },
  },
  Business: {
    fields: {
      accessControls: connectionTypePolicy,
      areaTypes: connectionTypePolicy,
      businessMemberships: connectionTypePolicy,
      createdAt: dateTypePolicy,
      documents: connectionTypePolicy,
      externalSystems: connectionTypePolicy,
      incidentTypes: connectionTypePolicy,
      incidents: connectionTypePolicy,
      inspectionReportPresets: connectionTypePolicy,
      inspectionReports: connectionTypePolicy,
      inspectionTemplates: connectionTypePolicy,
      inspections: connectionTypePolicy,
      inspectors: connectionTypePolicy,
      itemTypes: connectionTypePolicy,
      leaseAuditProjects: connectionTypePolicy,
      products: connectionTypePolicy,
      projectBoards: connectionTypePolicy,
      properties: connectionTypePolicy,
      propertyGroups: connectionTypePolicy,
      remoteSessions: connectionTypePolicy,
      roles: connectionTypePolicy,
      taskExportJobs: connectionTypePolicy,
      tasks: connectionTypePolicy,
      updatedAt: dateTypePolicy,
      userGroups: connectionTypePolicy,
      workTypes: connectionTypePolicy,
    },
  },
  BusinessMembership: {
    fields: {
      inactivatedAt: dateTypePolicy,
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
    },
  },
  Charge: {
    fields: {
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      archivedAt: dateTypePolicy,
      startDate: dateTypePolicy,
      endDate: dateTypePolicy,
    },
  },
  Device: { fields: { createdAt: dateTypePolicy, updatedAt: dateTypePolicy } },
  DeviceToken: { fields: { createdAt: dateTypePolicy } },
  Document: {
    fields: {
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      expiryDate: dateTypePolicy,
    },
  },
  Floor: {
    fields: { areas: connectionTypePolicy, units: connectionTypePolicy },
  },
  Incident: {
    fields: {
      createdAt: dateTypePolicy,
      occurredAt: dateTypePolicy,
      reportedAt: dateTypePolicy,
      statusChangedAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      archivedAt: dateTypePolicy,
      contacts: connectionTypePolicy,
      reports: connectionTypePolicy,
    },
  },
  IncidentContact: {
    fields: {
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      archivedAt: dateTypePolicy,
    },
  },
  IncidentForm: {
    fields: { createdAt: dateTypePolicy, updatedAt: dateTypePolicy },
  },
  IncidentReport: { fields: { createdAt: dateTypePolicy } },
  IncidentType: {
    fields: {
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      archivedAt: dateTypePolicy,
    },
  },
  Inspection: {
    fields: {
      createdAt: dateTypePolicy,
      dueBy: dateTypePolicy,
      endedAt: dateTypePolicy,
      footerFields: connectionTypePolicy,
      headerFields: connectionTypePolicy,
      ratingGroups: connectionTypePolicy,
      reports: connectionTypePolicy,
      scheduledFor: dateTypePolicy,
      sections: connectionTypePolicy,
      startedAt: dateTypePolicy,
      tasks: connectionTypePolicy,
      updatedAt: dateTypePolicy,
    },
  },
  InspectionItem: {
    fields: { photos: connectionTypePolicy, attachments: connectionTypePolicy },
  },
  InspectionReport: {
    fields: {
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      archivedAt: dateTypePolicy,
      generatedAt: dateTypePolicy,
      finalizedAt: dateTypePolicy,
      data: JSONTypePolicy,
    },
  },
  InspectionReportPreset: {
    fields: {
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      restrictedTo: connectionTypePolicy,
    },
  },
  InspectionReportSignatory: {
    fields: { generatedAt: dateTypePolicy, signedAt: dateTypePolicy },
  },
  InspectionSchedule: {
    fields: {
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      archivedAt: dateTypePolicy,
      nextDueAt: dateTypePolicy,
      locations: connectionTypePolicy,
    },
  },
  InspectionSection: { fields: { items: connectionTypePolicy } },
  InspectionTemplate: {
    fields: {
      archivedAt: dateTypePolicy,
      createdAt: dateTypePolicy,
      footerFields: connectionTypePolicy,
      headerFields: connectionTypePolicy,
      outlines: connectionTypePolicy,
      ratingGroups: connectionTypePolicy,
      restrictedTo: connectionTypePolicy,
      sections: connectionTypePolicy,
      updatedAt: dateTypePolicy,
    },
  },
  InspectionTemplateSection: { fields: { items: connectionTypePolicy } },
  JSONEdge: { fields: { node: JSONTypePolicy } },
  Lease: {
    fields: {
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      archivedAt: dateTypePolicy,
      leaseStart: dateTypePolicy,
      leaseEnd: dateTypePolicy,
      charges: connectionTypePolicy,
      occupancies: connectionTypePolicy,
    },
  },
  LeaseAudit: { fields: { completedAt: dateTypePolicy } },
  LeaseAuditProject: {
    fields: {
      expectedWalkDate: dateTypePolicy,
      leaseAudits: connectionTypePolicy,
    },
  },
  Location: {
    fields: {
      createdAt: dateTypePolicy,
      descendants: connectionTypePolicy,
      inspectionReports: connectionTypePolicy,
      inspections: connectionTypePolicy,
      leases: connectionTypePolicy,
      projects: connectionTypePolicy,
      residents: connectionTypePolicy,
      tasks: connectionTypePolicy,
      updatedAt: dateTypePolicy,
    },
  },
  NoEntryEvent: { fields: { createdAt: dateTypePolicy } },
  Occupancy: {
    fields: {
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      archivedAt: dateTypePolicy,
      moveInAt: dateTypePolicy,
      moveOutAt: dateTypePolicy,
      noticeGivenDate: dateTypePolicy,
    },
  },
  Project: {
    fields: {
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      archivedAt: dateTypePolicy,
      start: dateTypePolicy,
      dueAt: dateTypePolicy,
      heldAt: dateTypePolicy,
      completedAt: dateTypePolicy,
      moveInAt: dateTypePolicy,
      stages: connectionTypePolicy,
    },
  },
  ProjectBoard: {
    fields: {
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      archivedAt: dateTypePolicy,
      projects: connectionTypePolicy,
    },
  },
  ProjectColumn: {
    fields: { dueAt: dateTypePolicy, completedAt: dateTypePolicy },
  },
  ProjectStage: {
    fields: {
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      archivedAt: dateTypePolicy,
      dueAt: dateTypePolicy,
      completedAt: dateTypePolicy,
      tasks: connectionTypePolicy,
      inspections: connectionTypePolicy,
    },
  },
  ProjectTemplate: {
    fields: {
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      archivedAt: dateTypePolicy,
    },
  },
  Property: {
    fields: {
      groups: connectionTypePolicy,
      areas: connectionTypePolicy,
      buildings: connectionTypePolicy,
    },
  },
  PropertyGroup: { fields: { properties: connectionTypePolicy } },
  RemoteSession: {
    fields: {
      archivedAt: dateTypePolicy,
      completedAt: dateTypePolicy,
      createdAt: dateTypePolicy,
      scheduledFor: dateTypePolicy,
      updatedAt: dateTypePolicy,
    },
  },
  Resident: {
    fields: {
      createdAt: dateTypePolicy,
      occupancies: connectionTypePolicy,
      updatedAt: dateTypePolicy,
    },
  },
  Role: { fields: { createdAt: dateTypePolicy, updatedAt: dateTypePolicy } },
  Share: {
    fields: {
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      expiryDate: dateTypePolicy,
    },
  },
  Task: {
    fields: {
      activities: connectionTypePolicy,
      attachments: connectionTypePolicy,
      completedAt: dateTypePolicy,
      createdAt: dateTypePolicy,
      dueAt: dateTypePolicy,
      heldAt: dateTypePolicy,
      scheduledFor: dateTypePolicy,
      updatedAt: dateTypePolicy,
    },
  },
  TaskActivityAssigneeChanged: { fields: { performedAt: dateTypePolicy } },
  TaskActivityAttachmentAdded: { fields: { performedAt: dateTypePolicy } },
  TaskActivityAttachmentRemoved: { fields: { performedAt: dateTypePolicy } },
  TaskActivityComment: { fields: { performedAt: dateTypePolicy } },
  TaskActivityCompleted: { fields: { performedAt: dateTypePolicy } },
  TaskActivityCreated: { fields: { performedAt: dateTypePolicy } },
  TaskActivityDescriptionChanged: { fields: { performedAt: dateTypePolicy } },
  TaskActivityDueDateChanged: {
    fields: {
      performedAt: dateTypePolicy,
      oldDueDate: dateTypePolicy,
      newDueDate: dateTypePolicy,
    },
  },
  TaskActivityEmergencyRequestViewed: {
    fields: { performedAt: dateTypePolicy },
  },
  TaskActivityEntryNotesChanged: { fields: { performedAt: dateTypePolicy } },
  TaskActivityInspectionPhotosChanged: {
    fields: { performedAt: dateTypePolicy },
  },
  TaskActivityLocationChanged: { fields: { performedAt: dateTypePolicy } },
  TaskActivityPermissionToEnterChanged: {
    fields: { performedAt: dateTypePolicy },
  },
  TaskActivityPhoneCallMade: {
    fields: { performedAt: dateTypePolicy, callStartAt: dateTypePolicy },
  },
  TaskActivityPriorityChanged: { fields: { performedAt: dateTypePolicy } },
  TaskActivityProjectStageChanged: { fields: { performedAt: dateTypePolicy } },
  TaskActivityReportingResidentAutoNotifyChanged: {
    fields: { performedAt: dateTypePolicy },
  },
  TaskActivityReportingResidentChanged: {
    fields: { performedAt: dateTypePolicy },
  },
  TaskActivityResidentNotified: { fields: { performedAt: dateTypePolicy } },
  TaskActivityResidentSurveySubmitted: {
    fields: { performedAt: dateTypePolicy },
  },
  TaskActivitySMS: { fields: { performedAt: dateTypePolicy } },
  TaskActivityScheduledForChanged: {
    fields: {
      performedAt: dateTypePolicy,
      oldScheduledFor: dateTypePolicy,
      newScheduledFor: dateTypePolicy,
    },
  },
  TaskActivityStatusChanged: { fields: { performedAt: dateTypePolicy } },
  TaskActivitySubStatusChanged: { fields: { performedAt: dateTypePolicy } },
  TaskActivityTimeSpentChanged: { fields: { performedAt: dateTypePolicy } },
  TaskActivityTimerStarted: {
    fields: { performedAt: dateTypePolicy, startedAt: dateTypePolicy },
  },
  TaskActivityTimerStopped: {
    fields: { performedAt: dateTypePolicy, stoppedAt: dateTypePolicy },
  },
  TaskActivityUnitEnteredChanged: { fields: { performedAt: dateTypePolicy } },
  TaskActivityVendorAccepted: { fields: { performedAt: dateTypePolicy } },
  TaskActivityVendorNotified: { fields: { performedAt: dateTypePolicy } },
  TaskActivityVendorRejected: { fields: { performedAt: dateTypePolicy } },
  TaskActivityWorkCategoryChanged: { fields: { performedAt: dateTypePolicy } },
  TaskAttachment: { fields: { createdAt: dateTypePolicy } },
  TaskInspectionDetails: { fields: { photos: connectionTypePolicy } },
  Unit: {
    fields: {
      areas: connectionTypePolicy,
      leaseAudits: connectionTypePolicy,
      occupancies: connectionTypePolicy,
    },
  },
  User: {
    fields: {
      accessGrants: connectionTypePolicy,
      accessible: connectionTypePolicy,
      businessMemberships: connectionTypePolicy,
      createdAt: dateTypePolicy,
      inspectionsAssigned: connectionTypePolicy,
      lastSignInAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      userGroups: connectionTypePolicy,
    },
  },
  UserGroup: {
    fields: {
      createdAt: dateTypePolicy,
      updatedAt: dateTypePolicy,
      users: connectionTypePolicy,
      roles: connectionTypePolicy,
      accessControls: connectionTypePolicy,
    },
  },
  Vendor: {
    fields: {
      archivedAt: dateTypePolicy,
      attachments: connectionTypePolicy,
      createdAt: dateTypePolicy,
      restrictedTo: connectionTypePolicy,
      updatedAt: dateTypePolicy,
    },
  },
  VendorAttachment: { fields: { createdAt: dateTypePolicy } },
  WorkCategory: {
    fields: {
      children: connectionTypePolicy,
      restrictedTo: connectionTypePolicy,
    },
  },
  WorkType: { fields: { workCategories: connectionTypePolicy } },
}
